import { createContext, useContext, useState, useEffect } from 'react';
import { instanceApi } from '../services/api';

const InstanceModeContext = createContext({ mode: null, isOES: false, isCoordinator: true, pureOES: false });

export default function InstanceModeProvider({ children }) {
  const [mode, setMode] = useState(null);

  useEffect(() => {
    instanceApi.getMode()
      .then(r => setMode(r.data?.mode || 'coordinator'))
      .catch(() => setMode('coordinator'));
  }, []);

  const isOES = mode === 'oes' || mode === 'dual';
  const isCoordinator = mode === 'coordinator' || mode === 'dual';
  const pureOES = mode === 'oes';

  return (
    <InstanceModeContext.Provider value={{ mode, isOES, isCoordinator, pureOES }}>
      {children}
    </InstanceModeContext.Provider>
  );
}

export function useInstanceMode() {
  return useContext(InstanceModeContext);
}
